import { h } from '@atomify/jsx';
import { Image } from '@bpd-library/components';
import { nextEvent } from '@utilities/next-event';

export const imageSwap = async (
    imageContainer: HTMLElement,
    source: string,
): Promise<HTMLImageElement> => {
    const imageElement = (
        <Image
            image={source}
            preload={{ width: 200 }}
            settings={{
                '640w': {
                    width: 640,
                },
                '1280w': {
                    width: 1280,
                },
                '1920w': {
                    width: 1920,
                },
                '2560w': {
                    width: 2560,
                },
            }}
            classes="vr-tour-image-view__image"
            alt=""
        />
    );
    const image = imageElement.querySelector<HTMLImageElement>('img') as HTMLImageElement;

    if (imageContainer.querySelector<HTMLElement>('.vr-tour-image-view__image')) {
        imageContainer.innerHTML = '';
    }

    imageContainer.append(imageElement);
    await nextEvent(image, 'load');

    return image;
};
